import { render, staticRenderFns } from "./AddClientProvider.vue?vue&type=template&id=1b0d7c7c&"
import script from "./AddClientProvider.vue?vue&type=script&lang=js&"
export * from "./AddClientProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports